__turbopack_context__.v({
  "card": "style-module-scss-module__tGKNza__card",
  "cards": "style-module-scss-module__tGKNza__cards",
  "container": "style-module-scss-module__tGKNza__container",
  "industryCards": "style-module-scss-module__tGKNza__industryCards",
  "industryCardsThree": "style-module-scss-module__tGKNza__industryCardsThree",
  "subtitle": "style-module-scss-module__tGKNza__subtitle",
  "title": "style-module-scss-module__tGKNza__title",
  "videoWrapper": "style-module-scss-module__tGKNza__videoWrapper",
  "wrapper": "style-module-scss-module__tGKNza__wrapper",
});
